import update from 'immutability-helper'
import clsx from 'clsx'
import React from 'react'
import {makeStyles} from 'external/material'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'
import Dialog from '../../../responsive-fullscreen-dialog'

const useStyles = makeStyles(configurationStyles)
const useDialogStyles = makeStyles(dialogStyles)

export default function ConfigurationDialog ({isOpen, onClose, context, updateAssessmentProperty}) {

  const dialogClasses = useDialogStyles()
  const classes = useStyles() 
  const {translate, quizAssessment: assessment} = context
  const {randomize = false} = assessment.properties || {}

  return (
    <Dialog
      open={isOpen}
      close={onClose}
      dialogMaxWidth="lg"
      actionsClassName={classes.actions}
      dialogClasses={dialogClasses}
      cancel={
        <Button
          variant="contained"
          className={clsx(classes.button, "close")}
          onClick={onClose}>
            {translate('close')}
        </Button>
      }
      title={translate('assessment-configuration-dialog-title')}
    >
      <Box className={classes.root}>
        <FormControlLabel
          size="small"
          className={classes.randomizeOption}
          control={
            <Checkbox
              size="small"
              color="primary"
              checked={randomize} 
              onChange={e => updateAssessmentProperty('randomize', e.target.checked)}
            />
          }
          label={translate('randomize-assessment')}
        />
      </Box>
    </Dialog>
  )
}

function configurationStyles(theme) {

  return {
    root: {
      color: '#4c4f58'
    },
    actions: {
      marginTop: 20
    },
  }
}

function dialogStyles(theme) {

  return {
    paper: {
      padding: 20
    },
  }
}

